import { Router } from '@angular/router';

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  DropdownItem,
  DropdownItemActionTypeEnum,
} from '../../../dynamic-dropdown/dynamic-dropdown.component';
import {
  OfferItem,
  Offer_Payment_Type_Enum,
} from 'src/app/components/user-dashboard/offer/models/offer';
import { PageItem, PageItemStatusEnum } from 'src/app/models/portal';
import { ApiService, PromptingService } from 'src/app/shared/services';
import { lastValueFrom, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { deleteWebsitePage } from 'src/app/shared/store/_features/website/website.actions';
import { ToastrService } from 'ngx-toastr';
import { SharedPortalViewService } from 'src/app/components/user-dashboard/portal/view/shared-portal-view.service';

@Component({
  selector: 'app-page-list-item',
  templateUrl: './page-list-item.component.html',
  styleUrls: ['./page-list-item.component.css'],
})
export class PageListItemComponent implements OnInit {
  page: PageItem;
  @Input('page') set setPage(page: PageItem) {
    this.page = page;
    this.generateOfferDropdown();
  }

  @Output() onDeleteDone: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloneDone: EventEmitter<PageItem> = new EventEmitter<PageItem>();
  @Output() onEditSettings: EventEmitter<PageItem> =
    new EventEmitter<PageItem>();
  @Output() onEditLegalContent: EventEmitter<PageItem> =
    new EventEmitter<PageItem>();
  // onClickRouter:string | any[];
  dropdownItems: DropdownItem[] = [];

  // offerProductNameMatches: boolean = false;
  constructor(
    private router: Router,
    private api: ApiService,
    private store: Store,
    private toastr: ToastrService,
    private prompting: PromptingService,
    private sharedPortalViewService: SharedPortalViewService,
  ) {}

  ngOnInit() {
    this.generateOfferDropdown();
    // this.offerProductNameMatches = this.offer.products?.length && this.offer.title.includes(this.offer.products[0].name);
    // switch (this.product.type.name) {
    //   case 'course':
    //     this.generateCourseDropdown()
    //     break;
    //     case 'downloadable':
    //     this.generateDownloadableDropdown()
    //     break;
    //   default:
    //     break;
    // }
  }

  // get offerProductNameMatches() {
  //   return this.offer.products?.length && this.offer.title.includes(this.offer.products[0].name)
  // }

  generateOfferDropdown() {
    // this.onClickRouter = ['/dashboard', 'offer', this.page.id, 'edit'];

    this.dropdownItems = [
      {
        label: 'Preview Page',
        iconSvg: 'assets/images/svg/system/preview.svg',
        type: DropdownItemActionTypeEnum.normal,
        colorSet: 'gray-700',
        colorSetHover: 'primary',
        action: () => {
          this.goToPreview();
        },
      },
      this.page.isLegal
        ? {
            label: 'Edit Content',
            iconSvg: 'assets/images/svg/system/edit.svg',
            type: DropdownItemActionTypeEnum.normal,
            colorSet: 'gray-700',
            colorSetHover: 'primary',
            action: () => {
              this.onEditLegalContent.emit(this.page);
            },
          }
        : {
            label: 'Edit Details',
            iconSvg: 'assets/images/svg/system/edit.svg',
            type: DropdownItemActionTypeEnum.portal,
            colorSet: 'gray-700',
            colorSetHover: 'primary',
            // routerLink: `?p=${ this.page?.id }&brizy-edit`,
            routerLink: `http://${this.page.url}/?builder=learmo&id=${this.page?.id}`,
          },
      {
        label: 'Page Settings',
        iconSvg: 'assets/images/svg/system/settings.svg', // Assuming this icon exists or similar
        type: DropdownItemActionTypeEnum.normal,
        colorSet: 'gray-700',
        colorSetHover: 'primary',
        action: () => {
          this.onEditSettings.emit(this.page);
        },
      },
      // {
      //   label: 'Duplicate',
      //   iconSvg: 'assets/images/svg/system/copy.svg',
      //   colorSet: 'gray-700',
      //   colorSetHover: 'primary',
      //   action : () => {
      //     this.clonePage(this.page)
      //   },
      // },
      this.page.status === PageItemStatusEnum.system
        ? { forceHide: true, colorSet: null, iconSvg: null, label: null }
        : undefined,
      {
        label: 'Delete',
        iconSvg: 'assets/images/svg/system/trash.svg',
        colorSet: 'danger',
        forceHide: this.page.status === PageItemStatusEnum.system,
        colorSetHover: 'danger',
        action: () => {
          this.deletePage(this.page);
        },
      },
    ];
  }

  clonePage = async (page: PageItem) => {
    // let offerClone: OfferItem = await this.sharedOfferService.cloneOfferAlert(offer);
    // if (!!offerClone) {
    //   this.onCloneDone.emit(offerClone)
    // }
  };

  deletePage = async (page: PageItem) => {
    this.prompting
      .confirm(
        {
          title: 'Are you sure want to delete?',
          html: `
        You will not be able to recover this Page
        `,
          icon: 'error',
          input:
            page.status == PageItemStatusEnum.published
              ? 'checkbox'
              : undefined,
          inputPlaceholder: `I am sure that i'll lose my deleted page.`,
          preConfirm: async () => {
            return await this.deletePageRequest(page);
          },
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          inputValidator: (result) => {
            return !result && 'You need to agree';
          },
          isDanger: true,
        },
        'md',
      )
      .then((res) => {
        if (res.isConfirmed && res.value?.success) {
          this.store.dispatch(deleteWebsitePage({ page }));
          this.toastr.success(`Page Deleted Successfully`);
          return true;
        } else {
          return false;
        }
      });
  };

  async deletePageRequest(page: PageItem) {
    let request$ = this.api.deletePage(page.id);

    let response: { success: boolean } = await lastValueFrom(request$);

    return response;
  }

  goToPreview() {
    const website = this.sharedPortalViewService.currentWebsite.website;
    if (!website) return;

    this.api
      .createPreviewSession(undefined, undefined, 'student')
      .subscribe((res: any) => {
        if (res && (res.token || res.tokenType === 'guest')) {
          const domain = !!website.siteUrl.startsWith('http')
            ? website.siteUrl
            : `https://${website.siteUrl}`;
          const targetPath = `/${this.page.slug}`;

          const previewUrl =
            res.tokenType === 'guest'
              ? `${domain}/preview?token=guest&path=${encodeURIComponent(
                  targetPath,
                )}`
              : `${domain}/preview?token=${res.token}&path=${encodeURIComponent(
                  targetPath,
                )}`;

          window.open(previewUrl, '_blank');
        }
      });
  }
}
